/**
 * @ngdoc service
 * @name components.service:SelectBox
 *
 * @descripton
 *
 */
angular
    .module('festzelt-os.components')
    .factory('pusherFactory', [
        'Env',
        '$pusher',
        pusherFactory
    ]);

function pusherFactory(Env, $pusher) {
    if (!window.Pusher) {
        return {
            subscribe: function () {
                return {
                    bind: function () {
                    }
                }
            },
        };
    }
    return $pusher(new Pusher(Env.puher.key, {
        cluster: Env.pusher.cluster,
        wsHost: Env.pusher.host,
        encrypted: Env.pusher.encrypted
    }));
}



// WEBPACK FOOTER //
// ./src/app/components/services/pusher/pusher-factory.js